import { render } from "./GuideDownloadButton.vue?vue&type=template&id=0b9798c0&scoped=true"
import script from "./GuideDownloadButton.vue?vue&type=script&lang=js"
export * from "./GuideDownloadButton.vue?vue&type=script&lang=js"

import "./GuideDownloadButton.vue?vue&type=style&index=0&id=0b9798c0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9798c0"]])

export default __exports__